import React from 'react';
import { Box, FormControl, FormHelperText } from '@mui/material';
import { Spinner } from '../../../Spinner';
import styles from './InvoiceEditFileSelector.module.scss';
import {
	InvoiceEditFileSelectorDisplayText,
	InvoiceEditFileSelectorDisplayTextProps,
} from './InvoiceEditFileSelectorDisplayText';
import { gql, DocumentNode } from '@apollo/client';
import classNames from 'classnames';
import { InvoiceEditFileSelectorInvoiceFragment } from '#types';

const invoiceEditFileSelectorInvoiceFragment = gql`
	fragment invoiceEditFileSelectorInvoice on Invoice {
		...invoiceEditFileSelectorDisplayTextInvoice
	}
	${ InvoiceEditFileSelectorDisplayText.fragments
		.invoiceEditFileSelectorDisplayTextInvoiceFragment }
`;

export type InvoiceEditFileSelectorProps = {
	className?: string;
	invoice?: Omit<InvoiceEditFileSelectorInvoiceFragment, 'id'> & {
		id?: string;
	};
	errorText?: string;
	isUploading: boolean;
} & Pick<
InvoiceEditFileSelectorDisplayTextProps,
| 'filename'
| 'file'
| 'setFile'
| 'intentToChangeOrDeleteCurrentAttachmentFile'
| 'setIntentToChangeOrDeleteCurrentAttachmentFile'
>;

export const InvoiceEditFileSelector: React.FC<InvoiceEditFileSelectorProps> & {
	fragments: { invoiceEditFileSelectorInvoiceFragment: DocumentNode };
} = ( {
	className: classNameProp,
	invoice,
	isUploading,
	errorText,
	...fileSelectorDisplayTextProps
} ) => {
	const className = classNames( styles.container, classNameProp, {
		[ styles.containerError ]: !!errorText,
	} );

	if ( isUploading ) {
		return (
			<Box className={ classNames( styles.action, className ) }>
				<span>Uploading File</span>
				<Spinner className={ styles.spinner } size={ 20 } />
			</Box>
		);
	}

	return (
		<FormControl className={ className } error={ !!errorText } variant='standard'>
			<InvoiceEditFileSelectorDisplayText
				invoice={ invoice }
				{ ...fileSelectorDisplayTextProps }
			/>
			{ errorText ? <FormHelperText>{ errorText }</FormHelperText> : null }
		</FormControl>
	);
};

InvoiceEditFileSelector.fragments = {
	invoiceEditFileSelectorInvoiceFragment,
};
